// Single-select-per-key toggle for record-metadata facets (metadata is
// map[string]string): picking a value replaces the key's value; picking the
// already-selected value clears the key. Never mutates the input.
export function toggleMetadataValue(
  selected: Record<string, string>,
  key: string,
  value: string,
): Record<string, string> {
  const next = { ...selected }
  if (next[key] === value) {
    delete next[key]
  } else {
    next[key] = value
  }
  return next
}
